import React, { useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import BeforeAuth from '../../BeforeAuth';
import { useLocation } from 'react-router-dom';

import Appbar from './Appbar';
import Footer from './Footer';

const useStyles = makeStyles((theme) => ({
  content: (props) => ({
    minHeight: 'calc(100vh - 64px - 56px)',
    marginTop: props.isHome ? '190px' : '120px',
  }),
}));

const Wrapper = (props) => {
  const location = useLocation();
  const isHome = location.pathname === '/xxx';
  const classes = useStyles({ isHome });


const shouldApplyPadding = [
	"/about-us",
	"/events",
	"/womens-day",
	"privacy-policy",
	"/homepage",
	"/webinar-user",
	"/webinars",
	"/",
	].includes(window.location.pathname) ||
	window.location.pathname.startsWith("/webinar-description") ||
	window.location.pathname.startsWith("/login");

	return (
	<>
	<Appbar />
	<Box className={classes.content}>
	{props.children}
	</Box>
	<Footer />
	</>
	);
};

export default Wrapper;